import axios, { AxiosError } from 'axios';

export function handleAxiosErrorMessage(error: AxiosError): string {
  let message = 'An unexpected error occurred';

  if (axios.isAxiosError(error) && error.response) {
    const responseData = error.response.data;

    if (typeof responseData === 'string') {
      message = responseData;
    } else if (responseData && typeof responseData === 'object' && 'message' in responseData) {
      message = (responseData as { message: string }).message;
    } else {
      message = JSON.stringify(responseData);
    }
  } else if (error.message) {
    message = error.message;
  }

  return message;
}
